import { render, staticRenderFns } from "./iconP5.vue?vue&type=template&id=c8b6ebd8&scoped=true&"
import script from "./iconP5.vue?vue&type=script&lang=js&"
export * from "./iconP5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b6ebd8",
  null
  
)

export default component.exports